import { FC, useState } from 'react';
import { Icon, Select } from 'common-components';
import styles from './progressFilter.module.scss';
import { progressFilterProps } from './filterTypes';

const ProgressFilter: FC<progressFilterProps> = (props: progressFilterProps) => {
    const { title, progressProperties, selectedItem, onSelect, filterRef } = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onClose = () => {
        setIsOpen(false);
    };

    return (
        <div className={styles['filter-container']} data-testid="filter-container">
            <span className={styles.label} data-testid="filter-lable">
                {title}
            </span>
            <div>
                <Select
                    dataTestid="filter-select"
                    list={progressProperties}
                    onChange={onSelect}
                    value={selectedItem}
                    className={styles.select}
                    inputClassName={styles['select-input']}
                    optionWidth="9rem"
                    filterRef={filterRef}
                    type="adminPanel"
                    notRenderIcon={true}
                    outerOpen={isOpen}
                    onClose={onClose}
                />
            </div>
            <Icon
                name={'downArrowIcon'}
                key={isOpen ? 'openIcon' : 'closeIcon'}
                className={isOpen ? styles['up-icon'] : styles.icon}
                onClick={() => setIsOpen(!isOpen)}
            />
        </div>
    );
};

export default ProgressFilter;
